import { Box } from '@mui/material';
import styles from './Status.module.scss';
import classNames from 'classnames/bind';
import { memo } from 'react';
import { StatusData } from '~/utils/interface/job';

const cx = classNames.bind(styles);

type StatusLabelProps = {
  variant: StatusData;
};

function Status(props: StatusLabelProps) {
  const { variant } = props;

  return (
    variant && (
      <Box
        className={cx('status-info')}
        style={{
          color: variant.color,
          backgroundColor: variant.backgroundColor,
        }}
      >
        {variant.name}
      </Box>
    )
  );
}

export default memo(Status);
